import type { FC } from "react";
import { AnimatePresence } from "motion/react";
import { type ClassNameProp, type ResponseVariant, Stack } from "@huub-web/ui";
import { useNavigationState } from "../../providers";
import { mergeClasses } from "@huub-web/utils";

import { useAppController } from "../../hooks/useAppController";
import { Response } from "./components/Response";

export type StreamingAgentResponseControllerProps = ClassNameProp & {
  showTemplates?: boolean;
  variant?: ResponseVariant;
  showFeedback?: boolean;
  showTime?: boolean;
  onChange?: () => void;
};

/**
 * Component that displays chat response messages.
 */
export const StreamingAgentResponseController: FC<
  StreamingAgentResponseControllerProps
> = ({
  showTemplates = false,
  variant = "hub",
  showTime = false,
  onChange,
  className,
}) => {
  const { agentResponses, agentResponseIDs } = useAppController();
  const { navigationContext } = useNavigationState();

  const filteredAgentResponses = Object.entries(agentResponses).filter(
    ([, chatMessage]) => {
      // If no navigation context is active, include all messages
      if (!navigationContext) {
        return true;
      }
      // If navigation context is active, only include messages that match it
      // Exclude messages without a context when navigation context is active
      if (!chatMessage.context) {
        return false;
      }
      // Check if contexts match
      return chatMessage.context.join(",") === navigationContext.join(",");
    },
  );

  // Get the last filtered response ID to display
  const currentResponseID =
    agentResponseIDs[agentResponseIDs.length - 1] ?? null;

  return (
    <Stack className={mergeClasses(className)} data-stack="responses">
      {filteredAgentResponses.map(([id, chatMessage]) => (
        <AnimatePresence key={chatMessage.id}>
          {currentResponseID === id && (
            <Response
              id={id}
              // className={mergeClasses(
              //   chatMessage.interaction
              //     ? messageContainerStyle({ apply: true })
              //     : undefined,
              // )}
              variant={variant}
              showTemplates={showTemplates}
              onChange={onChange}
              showTime={showTime}
              interactionLabel={chatMessage.interaction_label}
            />
          )}
        </AnimatePresence>
      ))}
    </Stack>
  );
};
